<template>
  <div class="home">
    <Alisure :mobile="mobile" :flag="flag" :key1="key1" :env="env" @sure="sure" :agree="agree" @cflag="cflag"
      @rule="rule" @ys="ys" />
    <img :src="`${img}bgt.png`" alt="" style="width: 100%" />

    <Right :tel="tel" :img="img" @rule="rule" />

    <div class="component">
      <Alipay :imgbtn="imgbtn" :color1="color1" :colorx="colorx" :btnHeight="80" :btnWidth="240" @parent-get="getnum" :value="value"
        :checkbox-color="ckColor" @flagx="flagx" @keys="keys" @env-change="getEnv" ref="comp" :productCode="productCode"
        :a="a" :img="img" @rule="rule" @ys="ys" :agree="agree" :color="colors" />
       <img :src="`${img}bgb.png`" alt="" class="bg" />

 <!-- <Bottom :text="text" :color="colors" class="bottom" /> -->
      <Rulex :show="show" :show1="show1" :title="title" :contentx="contentx" :content="content" :title1="title1"
        @close1="close1" @close="close" />

    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { userApi, traceApi } from '@/api/index.js'  // 导入命名导出
import Alipay from "@/components/Alipay.vue";
import Bottom from "@/components/Bottom.vue";
import Right from "@/components/Right.vue";
import Rulex from "@/components/Rulex.vue";
import Alisure from "@/components/Alisure.vue";
import BackTop from "@/components/BackTop.vue";
import MarqueeRoll from "@/components/MarqueeRoll.vue";


export default {
  name: "yd_hz",
  components: {
    Alipay,
    Bottom,
    Right,
    Rulex,
    Alisure,
    BackTop,
    MarqueeRoll

  },
  data() {
    return {
     
      colorx: 'color:#E0B661',//协议颜色
       color1: 'color:#E0B661',//协议颜色
     
      mobile: '',
      productCode: 'LH2645',
      value: "",
      ckColor: '#E0B661',//勾选框颜色
      key1: {},
      env: '',
      a: "",
      flag: false,
      title1: '隐私保护指引》',
      show1: false,
      title: "产品说明",
      show: false,
      colors: 'color:#E0B661',//底部颜色和协议颜色
      agree: [


        {
          name: '《隐私保护指引》',
          id: 1,
          url: ""
        },
        {
          name: '《会员服务协议》',
          id: 2,
          url: "https://web.78keji.cn/qbxy/"
        },

               {
          name: '《芒果会员服务协议》',
          id: 4,
          url: "https://club.mgtv.com/act/vip_static/protocol/zh-CHS/vip.html"
        },
               {
          name: '《芒果自动续费协议》',
          id: 5,
          url: "https://club.mgtv.com/act/vip_static/protocol/zh-CHS/auto-renew.html"
        },
        {
          name: '《产品说明》',
          id: 3,
          url: ""
        }

      ],
        img: "https://qb.78keji.cn/image/mg/",
      imgbtn:"https://qb.78keji.cn/image/mg/btn.gif",
      tel: '4006969196',
      text: [

        "业务资费：首次0.1元，3天后续订35.9元/月（随时取消）",
        "芒果tv会员月卡；30元支付宝立减金；省心app权益",
        "客服热线：400-6969-196",
      ],
           contentx: [
"1.活动时间：2025.06.01-2026.12.31",
"2.产品名称：芒果TV月卡会员 X支付宝立减金连续包月",
"3.客服咨询：在使用联合产品过程中对任一产品有疑问，可咨询客服热线400-696-9196（工作日8:00-22:00）",
"4.活动对象：所有正规支付宝注册用户且未购买过立减金类产品的用户，均可参与活动，具体以实际办理为准。",
"活动参与条件：",
"（1）首次参与活动用户需0.1元订购试用套餐【3天芒果TV会员体验卡】。该套餐每个用户限购一单；如您参与活动后取消了服务，该服务将无法再次购买。",
"（2）如已参加过35.9元购买【5元*6张支付宝通用立减金】+【芒果TV月卡会员】活动，则无法再次参加本次活动。",
"5.产品资费：本活动正式套餐为【省心购（支付宝立减金）+芒果TV月卡会员】连续包月产品。首次0.1元为试用套餐【3天芒果TV会员体验卡】，3天后自动续费35.9元/月，开通立即生效，到期后（以芒果TV月卡会员30天到期为准）自动续订（限购1单，可随时取消）。扣费采用签约代扣的方式进行，会在每一个计费周期到期前24小时自动从您签约的账户中扣费（请确保余额充足）。如对产品有异议或者建议等，请联系客服登记处理。",
"6.权益说明：",
"（1）权益内容包含：",
"①首次0.1元购买试用套餐，【3天芒果TV会员体验卡】，其中，芒果TV会员体验卡可体验芒果TV移动端免费内容的会员专享高清晰度画质。",
"②3天后自动续费连续包月（35.9元）权益包含【5元*6张支付宝通用立减金】+【芒果TV月卡会员】",
"③限时赠送权益（首次正式套餐赠送）：【省心APP100元购物金】+【省心APP购物优惠】。",
"（2）权益使用范围：",
"①支付宝通用立减金：可用场景为线上消费或线下实体店到店付款，单笔实际支付金额大于或者等于5.01元时可抵扣使用。使用立减金的订单若发生退款，订单可退金额及立减金可退金额以退款页面信息为准。退回的立减金若在有效期内则可继续使用，且使用规则不变；退回的立减金若已过有效期则无法使用，且不予补发。",
"②芒果TV月卡会员：适用于移动端、PAD端。",
"③限时赠送权益（首次购买赠送）",
 "A【省心APP100元购物金】：APP购物金板块购物可用，适用于淘宝精选商品，无门槛，可拆分使用，具体规则请以【省心App-首页-购物金页面】说明为准。",
 "B.【省心APP购物优惠】。：适用于淘宝、京东、拼多多、唯品会、小米有品、美团、饿了么、淘票票、团油等平台隐藏优惠券和购物佣金翻倍奖励，并且每下一单都有红包奖励，具体规则请以【省心App-我的-会员页面】说明为准。",
"（3）权益领取及使用：",
"①用户首次0.1元购买【3天芒果TV会员体验卡】，【3天芒果TV会员体验卡】将发放到您订购时选用的手机号对应的芒果TV账号上。该产品为虚拟商品，请确保手机号正确，否则无法退还。",
"②5天后续订连续包月产品包含【5元*6张支付宝通用立减金（共计30元）】+【芒果TV月卡会员】，其中：",
"A.【5元*6张支付宝通用立减金】",
"a.领取地址：小程序“省心智生活”小程序 -> 登录办理联合会员手机号->权益领取->选择订单领取您的立减金（领取详情见阅短信），领取规则为：每5天可领取一张，每月共可领取6张，过期后不可再领取，每张立减金领取后72小时内有效，到期后自动失效。支付宝立减金领取后将发放到您订购时选用的手机号注册的支付宝账户对应的卡包。该产品为虚拟商品，请确保手机号正确，否则无法退还。",
"b.支付宝立减金可用于线上线下任意支付宝支付场景（使用支付宝支付，且金额大于5元，选择银行卡【含所有银行卡】付款时均可自动抵扣）。",
"c.使用立减金的订单若发生退款，订单可退金额及立减金可退面额以消费者的退款页面信息为准。退回的立减金若在有效期内则可继续使用，且使用规则不变；退回的立减金若已过有效期则无法使用，且不予补发。",
"B.【芒果TV月卡会员】",
"芒果TV月卡会员将发放到用户订购时选用的手机号对应的芒果TV账号上，请确保通过活动订购产品的手机号和登录芒果TVAPP的手机号保持一致，凭订购产品时使用的手机号登录芒果TVAPP查看会员到账情况；",
"若您的账号已有芒果TV会员，则到账后自动为您延长30天芒果TV会员。该产品为虚拟商品，请确保手机号正确，否则无法退还。",
 "②省心连续包月权益限时赠送权益。【省心APP100元购物金】+【省心APP购物优惠】，其中：",
"A.【省心APP100元购物金】",
"直接发放至您所订购时填写的手机号对应注册的省心App账号下，凭订购产品时使用的手机号登录省心APP，登录省心App-首页-选择购物金，查看购物金到账情况；",
"B.【省心APP购物优惠】",
"直接发放至您所订购时填写的手机号对应注册的省心App账号下，凭订购产品时使用的手机号登录省心APP，登录省心App-首页-选择我的，查看会员到账情况。",
"（4）联合产品权益最长时限限制说明",
"①该联合产品初始订阅时限为2年，如无特殊情况将自动顺延订阅关系；",
"②如因联合产品运营情况等原因导致该联合产品提前终止的，则芒果TV或省心购将提前通知用户终止代扣。",
"③如活动终止代扣，但不影响用户使用已经代扣成功的联合产品权益。",
"7.取消订阅/续订：",
"（1）您在购买自动续费服务后，将会在到期前1天为您发起续费，自动延长一个月芒果TV月卡会员有效期及支付宝立减金权益；",
"（2）如需解约本产品，请在会员权益到期1天前解约。解约路径：打开支付宝APP点击设置-支付设置-免密支付自动扣款-选择需要退订的产品-关闭服务，取消后则不再发起续订扣费。",
"注意：在芒果TV与省心购（支付宝立减金）合作发生变更时，将提前通知您是否同意变更连包方案，如您不同意将自动解约；在芒果TV与省心购（支付宝立减金）合作终止时，您的订购服务将自动解约，请以届时实际通知为准。您在解约之前已经代扣成功的权益仍可以使用。",
"8.退费说明：联合产品属虚拟类商品，非预付卡，不适用无理由退货，开通成功后，不支持退款和转移，联合产品权益不可转让。",
"9.禁止事项：严禁以任何形式翻录或转载、未经许可在第三方平台传播，违者将追究法律责任。",
"10.特别提醒",
"（1）购买本联合产品，应同时遵守芒果TV和省心购各自发布的《用户服务协议》、《隐私权政策》（统称“平台规则”），如违反任一平台规则，芒果TV和省心购任何一方均有权单独按照其平台规则的规定进行处理，包括但不限于中止或终止提供其所属平台的服务及要求侵权赔偿等。故在开通前，请仔细阅读两个平台的规则。",
"（2）用户信息保护：为您领取权益目的，芒果TV和省心购会收集使用您的相关信息。当您购买联合产品并手动勾选相关服务协议后，表明您接受并同意收集使用您的个人信息。活动主办方使用个人信息仅限于购买、领取、使用联合产品所需，并在合理范围内予以保护，详细个人信息政策请阅读芒果TV和省心购《隐私权政策》及《用户服务协议》。如您不同意请不要参与本次活动。",
"（3）互联网存在诸多不确定性因素，因此理解并同意，如因不可抗力、网络、通讯线路故障、计算机大规模瘫痪及活动中存在大面积作弊行为等非芒果TV和省心购原因致使本活动出现异常情况或难以继续开展的，活动主办方有权采取包括但不限于通过各种方式消除异常情况或调整、暂停、取消本活动等措施，因此造成用户损失的，芒果TV和省心购不承担责任。",
"（4）如出现不可抗力或情势变更的情况（包括但不限于重大灾害事件，活动受政府机关指令需要停止举办或调整的，活动遭受严重网络攻击或因系统故障导致包括但不限于活动中断、停办、权益领取和使用出现问题），活动主办方可依据相关法律法规的规定主张免责，主办方拥有取消本次活动的权利。",
"（5）在法律规定的范围内，芒果TV和省心购有权对活动规则进行解释，并根据活动的实际情况对本活动的规则进行变动或调整，相关变动或调整将公布在本活动规则页面，公布后依法生效。",
"（6）如果用户出现违规行为（如作弊领取、恶意套现、刷取信誉、虚假交易、以所获得权益进行盈利、不当使用、倒买倒卖等违背诚实信用的行为），活动主办方将取消收回全部权益（含已使用的及未使用的），必要时追究法律责任。",
  ],
      content: [
        "用户协议",
        "尊敬的用户，欢迎使用由成都启奔科技有限公司（下列简称为“启奔科技”）提供的服务。在使用前请您阅读如下服务协议，使用本应用即表示您同意接受本协议，本协议产生法律效力，特别涉及免除或者限制启奔科技责任的条款，请仔细阅读。如有任何问题，可向启奔科技咨询。",
        "1. 服务条款的确认和接受",
        "通过访问或使用本应用，表示用户同意接受本协议的所有条件和条款。",
        "2. 服务条款的变更和修改",
        "启奔科技有权在必要时修改服务条款，服务条款一旦发生变更，将会在重要页面上提示修改内容。如果不同意所改动的内容，用户可以放弃获得的本应用信息服务。如果用户继续享用本应用的信息服务，则视为接受服务条款的变更。本应用保留随时修改或中断服务而不需要通知用户的权利。本应用行使修改或中断服务的权利，不需对用户或第三方负责。",
        "3. 用户行为",
        "3.1 用户账号、密码和安全",
        "您需注册登录账号方可使用我司产品功能。",
        "3.2 账号注册时的禁止行为",
        "（1）请勿以党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名注册；",
        "（2）冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或任何机构有关的名称；",
        "（3）请勿注册和其他网友之名相近、相仿的名字；",
        "（4）请勿注册不文明、不健康名字，或包含歧视、侮辱、猥亵类词语的名字；",
        "（5）请勿注册易产生歧义、引起他人误解的名字；",
        "3.3 用户在本应用上不得发布下列违法信息和照片：",
        "（1）反对宪法所确定的基本原则的；",
        "（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；",
        "（3）损害国家荣誉和利益的；",
        "（4）煽动民族仇恨、民族歧视，破坏民族团结的；",
        "（5）破坏国家宗教政策，宣扬邪教和封建迷信的；",
        "（6）散布谣言，扰乱社会秩序，破坏社会稳定的；",
        "（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；",
        "（8）侮辱或者诽谤他人，侵害他人合法权益的；",
        "（9）含有法律、行政法规禁止的其他内容的；",
        "（10）禁止骚扰、毁谤、威胁、仿冒网站其他用户；",
        "（11）严禁煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；",
        "（12）严禁发布可能会妨害第三方权益的文件或者信息，例如（包括但不限于）：病毒代码、黑客程序、软件破解注册信息。",
        "（13）禁止上传他人作品。其中包括你从互联网上下载、截图或收集的他人的作品；",
        "（14）禁止上传广告、横幅、标志等网络图片；",
        "4. 服务内容",
        "本服务的具体内容由启奔科技根据实际情况提供，启奔科技可以对其提供的服务予以变更，且启奔科技提供的服务内容可能随时变更。",
        "",
        "隐私条款",
        "1.用户信息公开情况说明",
        "尊重用户个人隐私是启奔科技的一项基本政策。所以，启奔科技不会在未经合法用户授权时公开、编辑或透露其注册资料及保存在本应用中的非公开内容，除非有下列情况：",
        "（1）有关法律规定或启奔科技合法服务程序规定；",
        "（2）在紧急情况下，为维护用户及公众的权益；",
        "（3）为维护启奔科技的商标权、专利权及其他任何合法权益；",
        "（4）其他需要公开、编辑或透露个人信息的情况；",
        "在以下（包括但不限于）几种情况下，启奔科技有权使用用户的个人信息：",
        "（1）在进行促销或抽奖时，启奔科技可能会与赞助商共享用户的个人信息，在这些情况下启奔科技会在发送用户信息之前进行提示，并且用户可以通过不参与来终止传送过程；",
        "（2）启奔科技可以将用户信息与第三方数据匹配；",
        "（3）启奔科技会通过透露合计用户统计数据，向未来的合作伙伴、广告商及其他第三方以及为了其他合法目的而描述启奔科技的服务；",
        "2.隐私权政策适用范围",
        "（1）用户在使用本应用服务器时留下的个人身份信息；",
        "（2）用户通过本应用服务器与其他用户或非用户之间传送的各种资讯；",
        "（3）本应用与商业伙伴共享的其他用户或非用户的各种信息；",
        "（4）启奔科技软件十分注重保护用户的个人隐私，并制定了《隐私政策》，用户亦可以通过《隐私政策》，用户确认并同意使用启奔科技软件提供的服务将被视为接受《隐私政策》。",
        "3.资讯公开与共享",
        "启奔科技不会将用户的个人信息和资讯故意透露、出租或出售给任何第三方。但以下情况除外：",
        "（1）用户本人同意与第三方共享信息和资讯;",
        "（2）只有透露用户的个人信息和资讯，才能提供用户所要求的某种产品和服务;",
        "（3）应代表本应用提供产品或服务的主体的要求提供（除非我们另行通知，否则该等主体无权将相关用户个人信息和资讯用于提供产品和服务之外的其他用途）：根据法律法规或行政命令的要求提供;因外部审计需要而提供;用户违反了本应用服务条款或任何其他产品及服务的使用规定;经本站评估，用户的帐户存在风险，需要加以保护。",
        "4.非个人隐私信息",
        "为了改善启奔科技软件的技术和服务，向用户提供更好的服务体验，启奔科技或可会自行收集使用或向第三方提供用户的非个人隐私信息。",
        "5.如何联系我们",
        "您可以通过以下方式与我们联系，我们将在15天内回复您的请求：",
        "（1）如对本政策内容、个人信息有任何疑问、意见或建议，您可通过启奔科技客服邮箱：【912716425@qq.com】与我们联系。",
        "（2）如发现个人信息可能被泄露，您可以联系我们的客服人员进行投诉举报；",
        "如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。",
      ],


    };
  },
  methods: {
    keys(e) {
      console.log(e, '获取的keys')
      this.key1 = e
    },
    getnum() {
 

      ap.getAuthCode({
        appId: '2021004123662489',
        scopes: ['auth_user'],
      }, (res) => {
             Toast.loading({
  message: '加载中...',
  forbidClick: true,
  duration:0
});
        this.point(3)
        if (res.authCode) {
          userApi.authorizeMobile({
            appId: "2021004123662489",
            code: res.authCode
          }).then((resx) => {

            this.value = resx.mobile
            var a = this.maskString(this.value)
            this.mobile = this.addSpaceEveryNChars(a, 3)

            this.$nextTick(() => {
              Toast.clear()
              this.$refs.comp.open(); // 此时组件已拿到value
            });
            traceApi.event({
              t: localStorage.getItem('traceId'),
              e: 4,
              obj: this.value
            })
          })
        }else{
           Toast.clear()
        }


      });
    },
    addSpaceEveryNChars(str, n) {
      return str.replace(new RegExp('.{1,' + n + '}', 'g'), '$& ');
    },
    maskString(str) {
      if (str.length <= 5) {
        return str.replace(/./g, '*');
      }
      return str.substr(0, 3) + str.substr(3, str.length - 5).replace(/./g, '*') + str.substr(-2);
    },
    getEnv(e) {

      this.env = e
    },
    sure() {
      console.log('点击确定')
      this.$refs.comp.pay();
    },
    point(e, n) {
      traceApi.event({
        t: localStorage.getItem('traceId'),
        e: e,
        f: n
      }).then((res) => {

      })
    },
    generateUUID() {
      // 使用更可靠的方法
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });

      // 移除所有横杠，取前26位
      const traceId = uuid.replace(/-/g, '').substring(0, 26);

      localStorage.setItem('traceId', traceId);
      return traceId;
    },
    cflag() {
      this.flag = false
    },
    flagx(e) {
      this.flag = e
    },
    ys(e) {
      this.show1 = e
    },
    rule(e) {
      this.point(6)
      this.show = e
    },
    close1(e) {
      this.show1 = e
    },
    close(e) {
      this.show = e
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = () => reject(new Error(`Script load failed: ${src}`));
        document.head.appendChild(script);
      });
    },
    init() {
      if (this.$route.query.a) {
        this.a = this.$route.query.a
        if (this.$route.query.traceId) {
          localStorage.setItem('traceId', this.$route.query.traceId)
           userApi.prepare({
          channelCode: this.a,
          productCode: this.productCode,
          traceId: localStorage.getItem('traceId')
        }).then((res1) => {

          this.getnum()


        })
        } else {
          this.generateUUID()//获取uuid
           traceApi.click({
          c: this.a,
          p: this.productCode,
          t: localStorage.getItem('traceId'),
          directUrl: document.referrer,//直接请求地址
          indirectUrl: ""	//间接请求地址
        }).then((res)=>{
           userApi.prepare({
          channelCode: this.a,
          productCode: this.productCode,
          traceId: localStorage.getItem('traceId')
        }).then((res1) => {

          this.getnum()


        })
        })
        }
       

      } else {
        this.$router.replace({
          path: '/404'
        })
      }
    }
  },
  // 1. 组件初始化阶段
  beforeCreate() {
    console.log(
      "1. [beforeCreate]: 实例初始化之后，data 和 methods 还未被创建。"
    );
    // 此时访问 this.count 会是 undefined
  },

  created() {
    if (this.$route.query.debug) {
      this.loadScript('https://pagespy.zzqz2024.com/page-spy/index.min.js')
        .then(() => {
          console.log('调试 SDK 加载完成');
        });
      this.loadScript('https://pagespy.zzqz2024.com/plugin/data-harbor/index.min.js')
        .then(() => {
          console.log('调试 SDK 加载完成');
        });
      this.loadScript('https://pagespy.zzqz2024.com/plugin/rrweb/index.min.js')
        .then(() => {
          console.log('调试 SDK 加载完成');
        });
      setTimeout(() => {
        window.$harbor = new DataHarborPlugin();
        window.$rrweb = new RRWebPlugin();

        [window.$harbor, window.$rrweb].forEach(p => {
          PageSpy.registerPlugin(p)
        })

        window.$pageSpy = new PageSpy({
          api: "pagespy.zzqz2024.com",
          clientOrigin: "https://pagespy.zzqz2024.com/",
          project: localStorage.getItem('traceId'),
          autoRender: false,
          title: window.location.href,
        });
        this.init()
      }, 1000)
    } else {
      this.init()
    }


  },
  // // 2. DOM挂载阶段
  // beforeMount() {
  //   console.log(
  //     "3. [beforeMount]: 模板编译完成，但尚未将虚拟DOM挂载到真实页面。"
  //   );
  //   // 此时访问 this.$el 会是 undefined (尚未挂载)
  // },

  // mounted() {
  //   console.log("4. [mounted]: 实例已挂载到DOM，可以安全地访问 this.$el 了。");
  //   console.log("   - 挂载的元素是:", this.$el);
  //   // 适合在此处操作DOM、使用第三方库初始化、设置定时器等
  // },

  // // 3. 更新阶段 (当数据变化时)
  // beforeUpdate() {
  //   console.log("5. [beforeUpdate]: 数据更新时，虚拟DOM重新渲染和打补丁之前。");
  //   console.log(`   - 数据即将从 ${this.previousCount} 变为 ${this.count}`);
  // },

  // updated() {
  //   console.log("6. [updated]: 数据更新后，虚拟DOM已重新渲染并完成打补丁。");
  //   console.log(`   - 数据更新已完成，当前计数是: ${this.count}`);
  //   // 注意：避免在此钩子中更改状态，可能导致无限循环。
  // },

  // // 4. 销毁阶段
  // beforeDestroy() {
  //   console.log("7. [beforeDestroy]: 实例销毁之前，组件仍完全可用。");
  //   // **重要**：在此处进行清理工作，如清除定时器、取消事件监听、取消未完成的异步请求等。

  //   console.log("   - 定时器已清理。");
  // },

  // destroyed() {
  //   console.log("8. [destroyed]: 实例销毁后，所有指令解绑，事件监听器被移除。");
  // },
};
</script>
<style scoped>
.home {
  background-color: #feefd0;
  min-height: 100vh

}

.component {
  margin-top: -10px;
}

.bottom {
  padding: 10px 0;
}


.bg {
  width: 100%;
  margin-top: 5px;
}
.left {
    /* position: absolute;
    top: 200px;
    z-index: 99; */
    margin-top: -40px;
}
</style>
